import React, { FC } from 'react';
import * as S from '../Forms.style';
import { FaCheck } from 'react-icons/fa';

interface RadioInputProps {
  label: string;
  name: string;
  value: string;
  register?: any;
  rules?: object;
  icon?: React.ReactNode;
  isActive?: boolean;
  isCheckmarkDisabled?: boolean;
}

export const RadioInput: FC<RadioInputProps> = ({
  label,
  name,
  value,
  register,
  rules,
  isActive = false,
  isCheckmarkDisabled = false,
}) => {
  return (
    <S.CustomRadio>
      <S.HiddenRadio type="radio" value={value} {...register?.(name, rules)} />
      <S.RadioContent isActive={isActive}>
        {!isCheckmarkDisabled && (
          <S.Checkmark>
            {/*
          // @ts-ignore */}
            <FaCheck />
          </S.Checkmark>
        )}
        <S.RadioTitle>{label}</S.RadioTitle>
      </S.RadioContent>
    </S.CustomRadio>
  );
};
